import React, { createContext, useState } from "react";

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [chatData, setChatData] = useState(null);

  const updateChatData = (data) => {
    setChatData(data);
  };

  return (
    <ChatContext.Provider value={{ chatData, updateChatData }}>
      {children}
    </ChatContext.Provider>
  );
};
